<template>
  <div>
    <QS-h4-title title="开票信息" />
    <QS-column-box
      :column="3"
      :source="data"
      labelWidth="150"
      separator=":"
      :list="invoicing"
    >
    </QS-column-box>
  </div>
</template>
<script setup>
import { ref } from 'vue'

const invoicing = ref([
  { key: 'taxPersonName', name: '纳税人名称' },
  { key: 'taxNo', name: '纳税人识别号' },
  { key: 'invoiceBankName', name: '开户行' },
  { key: 'invoiceAccountNo', name: '银行账号' },
  { key: 'invoiceTel', name: '电话' },
  { key: 'invoiceAddress', name: '地址' },
])

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
})
</script>
<script>
export default {
  name: 'Invoicing',
}
</script>
